const Roles = Object.freeze({ ADMIN: "ADMIN", SUPERUSER: "SUPERUSER", USER: "USER" });

export default Roles;